import handleRequestErrorMixin from "../views/handleRequestErrorMixin";
import constants from "../constants";
import h from "../services/h";
import { EventBus } from "../event-bus";
import vbIncomingDocUserViewService from "../services/vbIncomingDocUserViewService";
import vbOutgoingDocUserViewService from "../services/vbOutgoingDocUserViewService";
import commonRouteVbMixin from "./commonRouteVbMixin";

export default {
  name: "NotifyCard",
  mixins: [handleRequestErrorMixin, commonRouteVbMixin],
  data() {
    return {
      CV_MESSAGE_TYPES: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_GIAOVIEC,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_DANGKY,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TAMDUNG,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HUY,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CHANGE_DEADLINE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CAPNHAT_TIENDO,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.TK_TASK.COMMENT
      ],
      VB_MESSAGE_TYPE_V2: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_TUCHOI,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_KETTHUC,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC,
      ],
      NOTI_MESSAGE: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI,
      ],
      DOCUMENT_MESSAGE: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_APPROVE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_CREATE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_REJECT,
      ],
    };
  },
  computed: {
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    }
  },
  methods: {

    isViewTaskDetail(item) {
      return (
        this.isCVNotification(item) ||
        item.messageType ===
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CANHBAOQUAHAN
      );
    },

    isCVNotification(item) {
      return this.CV_MESSAGE_TYPES.indexOf(item.messageType) !== -1;
    },

    isNotiNotification(item) {
      return this.NOTI_MESSAGE.indexOf(item.messageType) !== -1;
    },

    isVbNotificationV2(item) {
      return this.VB_MESSAGE_TYPE_V2.indexOf(item.messageType) !== -1;
    },

    isDocument(item) {
      return this.DOCUMENT_MESSAGE.indexOf(item.messageType) !== -1;
    },

    changeUserDeptRoleGlobal(userDeptRoleId) {
      this.$store.commit("changeUserDeptRole", userDeptRoleId);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRoleId
      });
    },

    viewDocDetailV2(vbNotificationView) {
      let dataJson = JSON.parse(vbNotificationView.dataJson);
      let userDeptRole = this.findUserDeptRole_(vbNotificationView);
      let vbDelegateInfoId = vbNotificationView.vbDelegateInfoId;
      let docId;
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      switch (vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_TUCHOI:
          docId = dataJson.data.id;
          this.changeUserDeptRoleGlobal(userDeptRole.id);
          this.redirectToIncomingDocDetail(
            userDeptRole,
            docId,
            vbDelegateInfoId
          );
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH:
          docId = dataJson.vbIncomingDoc.id;
          this.changeUserDeptRoleGlobal(userDeptRole.id);
          this.redirectToIncomingDocDetail(
            userDeptRole,
            docId,
            vbDelegateInfoId
          );
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_KETTHUC:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_COMMENT:
          docId = dataJson.data.id;
          this.changeUserDeptRoleGlobal(userDeptRole.id);
          this.redirectToOutgoingDocDetail(
            userDeptRole,
            docId,
            vbDelegateInfoId
          );
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC:
          docId = dataJson.object.id;
          this.changeUserDeptRoleGlobal(userDeptRole.id);
          this.redirectToOutgoingDocDetail(
            userDeptRole,
            docId,
            vbDelegateInfoId
          );
          break;
      }
    },

    viewNotification(notifi) {
      let userDeptRole = this.findUserDeptRole_(notifi);
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToNotiDetail(notifi.docId, notifi);
    },

    viewNews(notifi) {
      let userDeptRole = this.findUserDeptRole_(notifi);
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToNewsDetail(notifi.docId, notifi);
    },

    viewDiscuss(discuss) {
      let userDeptRole = this.findUserDeptRole_(discuss);
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToDiscussDetail(discuss.docId, discuss)
    },

    viewDocument(document) {
      let userDeptRole = this.findUserDeptRole_(document);
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToDocumentDetail(document.docId, document)
    },

    viewLetter(letter) {
      let userDeptRole = this.findUserDeptRole_(letter);
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToLetter(letter.docId, letter)
    },

    viewHanhChinhPH(hanhchinh) {
      let info = JSON.parse(hanhchinh.dataJson);
      let userDeptRole = this.findUserDeptRole_(hanhchinh);
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToHanhChinhPHDetail(info.hcCasePhonghop.caseMasterId, hanhchinh)
    },

    viewHanhChinhDX(hanhchinh) {
      let info = JSON.parse(hanhchinh.dataJson);
      let userDeptRole = this.findUserDeptRole_(hanhchinh);
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToHanhChinhDXDetail(info.hcCaseDieuXe.hcCaseMasterId, hanhchinh)
    },

    viewHanhChinhLT(hanhchinh) {
      let info = JSON.parse(hanhchinh.dataJson);
      let userDeptRole = this.findUserDeptRole_(hanhchinh);
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      this.changeUserDeptRoleGlobal(userDeptRole.id);
      this.routeToHanhChinhLTDetail(info.hcCaseCalendar.caseMasterId, hanhchinh)
    },

    findUserDeptRole_(vbNotificationView) {
      if (vbNotificationView.toUserDeptRoleId) {
        return h.find(
          this.userDeptRoles,
          userDeptRole =>
            userDeptRole.id === vbNotificationView.toUserDeptRoleId
        );
      } else {
        return h.find(
          this.userDeptRoles,
          userDeptRole =>
            userDeptRole.userId === vbNotificationView.toUserId &&
            userDeptRole.deptId === vbNotificationView.toDeptId &&
            userDeptRole.roleId === vbNotificationView.toRoleId
        );
      }
    },

    redirectToIncomingDocDetail(userDeptRole, docId, vbDelegateInfoId) {
      vbIncomingDocUserViewService
        .findByDocId(docId, { vbDelegateInfoId: vbDelegateInfoId })
        .then(response => {
          let vbIncomingDocUserView = response.data[0];
          this.routeToVbIncomingDocDetail(
            docId,
            vbIncomingDocUserView,
            userDeptRole
          );
        })
        .catch(error => {
          this.commonHandleRequestError(error)
        });
    },

    redirectToOutgoingDocDetail(userDeptRole, docId, vbDelegateInfoId) {
      vbOutgoingDocUserViewService
        .findByDocId(docId, { delegateInfoId: vbDelegateInfoId })
        .then(response => {
          let vbOutgoingDocUserView = response.data[0];
          this.routeToVbOutgoingDocDetail(
            docId,
            vbOutgoingDocUserView,
            userDeptRole
          );
        });
      // .catch(error => {
      //   console.log("redirectToOutgoingDocDetail: error");
      //   console.log(JSON.stringify(error));
      //   throw error;
      //   return this.commonHandleRequestError(error)
      // });
    },

    viewTaskDetail(item) {
      let dataJson = JSON.parse(item.dataJson);
      let taskId = dataJson.tkTask.id;
      let userDeptRole = this.findUserDeptRole_(item);
      if (userDeptRole) {
        this.changeUserDeptRoleGlobal(userDeptRole.id);
        this.routeToTaskDetail(taskId, userDeptRole.id);
      } else {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
      }
    },

    viewDocDetail(item) {
      let info = JSON.parse(item.dataJson);
      let userDeptRole = this.findUserDeptRole_(item);
      let vbDelegateInfoId = item.vbDelegateInfoId;
      if (!userDeptRole) {
        this.$message({
          message: "Vai trò tương ứng không tồn tại!",
          type: "error"
        });
        return;
      }
      if (info.docType === constants.DOC_TYPE.VB_DEN) {
        this.changeUserDeptRoleGlobal(userDeptRole.id);
        this.redirectToIncomingDocDetail(
          userDeptRole,
          info.object.id,
          vbDelegateInfoId
        );
      } else if (info.docType === constants.DOC_TYPE.VB_DI) {
        this.changeUserDeptRoleGlobal(userDeptRole.id);
        this.redirectToOutgoingDocDetail(
          userDeptRole,
          info.object.id,
          vbDelegateInfoId
        );
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/notificationMixin.js